module.exports = __webpack_public_path__ + "static/img/vehicle_license.6d84ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/upload/vehicle_license.png
// module id = Ubgq
// module chunks = 1